import { SolucaoCalculadaOffGrid, TiposBaterias } from "src/components/projetos/types";
import { apiNoLoading,IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";

type GeracaoNecessariaInput = {
    consumo_diario: number
    latitude: number
    longitude: number
}

type GeracaoNecessariaOutput = {
    potencia: number
}

type CalcularQtdModulosInput = {
    moduloId: number;
    potencia: number;
}

type CalcularQtdModulosOutput = {
    quantidade: number;
    potencia_fotovoltaica: number;
}

type CalcularSolucaoInput = {
    tensao_saida: string;
    quantidade_modulos: number;
    tipo_bateria: TiposBaterias | null;
    autonomia_bateria: number;
    regioes: number[];
    potencia_fotovoltaica: number;
    consumo_total_diario: number;
    potencia_equipamentos: number;
}

export class ProjetosOffGridProvider extends AProvider {
    constructor() {
        super("/projetos/offgrid");
    }

    async calcularGeracaoNecessaria(request: GeracaoNecessariaInput): Promise<IDataResponse<GeracaoNecessariaOutput | null>> {
        if (!request.consumo_diario || !request.latitude || !request.longitude) {
            return {
                statusCode: STATUS_CODE.BAD_REQUEST,
                message: "Consumo diário, latitude e longitude são necessários.",
                data: null,
            }
        }

        const response: IDataResponse<GeracaoNecessariaOutput> = await apiNoLoading.post({
            url: `${this.path}/geracao/calcular`,
            data: {
                consumo_diario: request.consumo_diario,
                latitude: request.latitude,
                longitude: request.longitude
            }
        })

        if (response.statusCode !== STATUS_CODE.OK) {
            return {
                statusCode: response.statusCode,
                message: response.message || "Erro ao calcular geração necessária.",
                data: null
            }
        }

        return {
            ...response,
            data: {
                potencia: response.data?.potencia || 0
            }
        }
    }

    async calcularQtdModulos(request: CalcularQtdModulosInput): Promise<IDataResponse<CalcularQtdModulosOutput | null>> {
        if (!request.moduloId || !request.potencia) {
            return {
                statusCode: STATUS_CODE.BAD_REQUEST,
                message: "Módulo e potência são necessários.",
                data: null,
            }
        }

        const response: IDataResponse<CalcularQtdModulosOutput> = await apiNoLoading.post({
            url: `${this.path}/modulos/${request.moduloId}/calcular`,
            data: { potencia: request.potencia }
        })

        if (response.statusCode !== STATUS_CODE.OK) {
            return {
                statusCode: response.statusCode,
                message: response.message || "Erro ao calcular quantidade de módulos.",
                data: null
            }
        }

        return {
            ...response,
            data: {
                potencia_fotovoltaica: response.data.potencia_fotovoltaica || 0,
                quantidade: response.data.quantidade || 0
            }
        }
    }

    async calcularSolucao(request: CalcularSolucaoInput): Promise<IDataResponse<SolucaoCalculadaOffGrid | null>> {
        const response = await apiNoLoading.post({
            url: `${this.path}/dimensionamento/calcular`,
            data: request,
        })

        if (response.statusCode !== STATUS_CODE.OK) {
            return {
                statusCode: response.statusCode,
                message: response.message || "Erro ao calcular solução.",
                data: null,
            }
        }

        return {
            ...response,
            data: {
                baterias: response.data?.baterias || [],
                controladores: response.data?.controladores || [],
                inversores: response.data?.inversores || [],
                modulo: response.data?.modulo || null,
            },
        }
    }
}
